// src/components/ProtectedRoute.jsx

import React from "react";
import { Navigate } from "react-router-dom";
// IMPORTANT: Ensure the path to your token utility is correct
import { isAuthenticated } from "../utils/token";

/**
 * A component wrapper that ensures only authenticated users can access its children routes.
 * Redirects unauthenticated users to the /login page.
 * * @param {object} props - Component props
 * @param {React.ReactNode} props.children - The protected component to render (e.g., <Layout />)
 */
const ProtectedRoute = ({ children }) => {
  // Check if the user is authenticated using the utility function
  const authenticated = isAuthenticated();

  if (!authenticated) {
    // If NOT authenticated, redirect the user to the login page.
    // 'replace' ensures the login page replaces the current history entry,
    // so the user can't press "back" to access the protected page.
    return <Navigate to="/login" replace />;
  }

  // If authenticated, render the children components (the requested page)
  return children;
};

export default ProtectedRoute;
